import { KeyRecoilProps } from '@/shared/model';
import useTabStripManagementUIEffect from './useTabStripManagementUIEffect';

/**
 * Tracks whether the strips management tab currently has anything to show, rendering nothing itself.
 *
 * @param keyRecoil - Report store record key identifying which tab's slice of state this effect drives.
 * @returns Null, since this effect-only component renders no markup.
 */
export const TabStripManagermentUIEffect = ({ keyRecoil }: KeyRecoilProps): null => {
  useTabStripManagementUIEffect({ keyRecoil });
  return null;
};
